// import React from "react";

// function quilStyle({
//   minHeight,
//   showToolbar,
//   noBorder,
// }: {
//   minHeight: string;
//   showToolbar: boolean;
//   noBorder: boolean;
// }) {
//   if (noBorder) {
//     const noBorderStyles = {
//       "& .ql-container": {
//         minHeight: minHeight || "50px", // Initial height of content area
//         height: "auto", // Allows it to grow
//         overflow: "auto", // Optional: adds scrollbar if needed
//         border: "none !important",
//       },
//       "& .ql-editor": {
//         minHeight: minHeight || "50px", // Ensures editable area starts at 50px
//         height: "auto", // Grows with content
//         padding: "8px", // Adjust padding if needed
//         backgroundColor: "white",
//       },

//       "& .ql-toolbar.ql-snow": {
//         //   p: "0px !important",
//         //   m: "0px !important",
//         borderTop: "1px solid #E3E3E3",
//         borderBottom: "1px solid #E3E3E3",
//         borderLeft: "none",
//         borderRight: "none",
//       },
//       "& .ql-snow.ql-toolbar button": {
//         borderRadius: "6px",
//         width: "32px",
//         height: "32px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "7px",
//       },
//     };
//     return noBorderStyles;
//   } else if (!noBorder) {
//     const baseStyles = {
//       "& .ql-container": {
//         minHeight: minHeight || "50px", // Initial height of content area
//         height: "auto", // Allows it to grow
//         overflow: "auto", // Optional: adds scrollbar if needed
//         border: "none !important",
//       },
//       "& .ql-editor": {
//         minHeight: minHeight || "50px", // Ensures editable area starts at 50px
//         height: "auto", // Grows with content
//         padding: "8px", // Adjust padding if needed
//         backgroundColor: "#F6F6F5",
//         borderRadius: "4px",
//       },
//       border: "1px solid #EDEDED",
//       borderTop: showToolbar ? "none" : "1px solid #EDEDED",
//       // borderRadius: "6px",

//       "& .ql-toolbar.ql-snow": {
//         //   p: "0px !important",
//         //   m: "0px !important",
//         borderTop: "1px solid #E3E3E3",
//         borderBottom: "1px solid #E3E3E3",
//         borderLeft: "none",
//         borderRight: "none",
//         //   borderRadius:
//         //     "6px 6px 0 0" /* Top-left and top-right corners rounded */,
//       },
//       "& .ql-snow.ql-toolbar button": {
//         borderRadius: "6px",
//         width: "32px",
//         height: "32px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "7px",
//       },
//     };
//     return baseStyles;
//   }

//   // Select which style to apply
//   //   const appliedStyles = noBorder ? noBorderStyles : baseStyles;
// }

// export default quilStyle;

function quilStyle({
  minHeight,
  showToolbar,
  noBorder,
  backgroundColor = "#F6F6F5",
  width,
  lineHeight = "1.65",
  backgroundColorEditor = "",
}: {
  minHeight: string;
  showToolbar: boolean;
  noBorder: boolean;
  backgroundColor?: string;
  width?: string;
  lineHeight?: string;
  backgroundColorEditor?: string;
}) {
  // Common styles for both bordered and borderless versions
  const commonStyles = {
    "& .ql-container": {
      minHeight: minHeight || "50px",
      height: "auto",
      overflow: "auto",
      border: "none !important",
    },
    "& .ql-editor": {
      minHeight: minHeight || "50px",
      height: "auto",
      padding: "8px",
      backgroundColor:
        backgroundColorEditor || noBorder ? "white" : backgroundColor,
      borderRadius: noBorder ? "0" : "4px",
      lineHeight: lineHeight,
    },
    "& .ql-toolbar.ql-snow": {
      borderTop: "1px solid #E3E3E3",
      borderBottom: "1px solid #E3E3E3",
      borderLeft: "none",
      borderRight: "none",
    },
    "& .ql-snow.ql-toolbar button": {
      borderRadius: "6px",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "7px",
    },
    width: width,
  };

  if (noBorder) {
    return {
      ...commonStyles,
      "& .ql-container": {
        ...commonStyles["& .ql-container"],
        border: "none !important",
      },
      "& .ql-editor": {
        ...commonStyles["& .ql-editor"],
        backgroundColor: backgroundColorEditor || "white",
      },
    };
  } else {
    return {
      ...commonStyles,
      border: "1px solid #EDEDED",
      borderTop: showToolbar ? "none" : "1px solid #EDEDED",
      borderRadius: "6px",
      "& .ql-editor": {
        ...commonStyles["& .ql-editor"],
        backgroundColor: backgroundColor,
        borderRadius: "4px",
      },
    };
  }
}

export default quilStyle;
